<template>
  <section id="donate" class="flex p-4 pb-10 md:p-10 flex-wrap overflow-x-hidden">
    <div class="md:w-3/4">
      <h3 class="text-3xl md:text-6xl leading-tight lg:max-w-xl mb-8 ">
        Every contribution makes a difference.
      </h3>
      <div id="donatetext" class="text-lg lg:max-w-2xl ">
        <p>
          Casey House is able to deliver compassionate care that transforms
          lives because donors believe in our team and believe in our clients.
          Whether you donate the amount of an Art With Heart ticket or Patrons’
          Circle membership, it will be doubled thanks to a generous donor who
          is matching each gift up to $50,000! Thank you for contributing to
          Ontario’s HIV/AIDS hospital.
        </p>
      </div>

      <AnimatedButton @click.native="showWidget=!showWidget" class="text-4xl" id="donatebtn">
        Donate Now
        <svg id="arrow" viewBox="0 0 250 50">
          <path
            class="tip"
            stroke="#19324F"
            stroke-width="5"
            stroke-linecap="round"
            d="M19.18,2.45A201.42,201.42,0,0,0,3.49,23.3a1.14,1.14,0,0,0-.27.76,1.17,1.17,0,0,0,.51.7,183.81,183.81,0,0,0,20,14.43"
            style="fill: none"
          />
          <path
            class="arrow"
            stroke="#19324F"
            stroke-width="5"
            stroke-linecap="round"
            d="M4.1,23.38C51,25.3,98,27.22,144.79,23.73c24.91-1.86,49.7-5.26,74.69-5.42"
            style="fill: none"
          />
        </svg>
      </AnimatedButton>
    </div>

    <div id="donatewidgetwrapper" class="w-full">
      <iframe v-show="showWidget"
        width="100%"
        height="480"
        src="https://caseyhouse.com/love/donatenow.html"
        frameborder="0"
        id="iframe"
        scrolling="no"
      >
      </iframe>
    </div>

  </section>
</template>

<script>
import AnimatedButton from "@/components/AnimatedButton.vue";
export default {
  name: "Donate",
  components: {
    AnimatedButton,
  },
    watch:{

      showWidget(newval,oldval) {
      // var iFrameID = document.getElementById('iframe');
              // console.log("scrolltent", iFrameID.contentWindow.document.body.scrollHeight );

      // if(iFrameID) {
            // here you can make the height, I delete it first, then I make it again
            // iFrameID.height = "";
            // iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + "px";
      // }   
  }

  },
  data: function() {
    return {
      showWidget: false,
    };
  },
};
</script>


<style scoped>

#donatebtn{
  cursor: pointer;
}

#donatewidgetwrapper	iframe{
		overflow:hidden; 
		width:100%;
		min-height: 1200px;
		overflow-y: hidden; 
		overflow-x: hidden;  
	}
	



#donate {
  background-color: #ffd4ce;
  position: relative;
  background-image: url("~@/assets/img/recursive_heart.png");
  background-repeat: no-repeat;
  background-position: right -20% center;
  background-size: 50%;
}

</style>
